<template>
  <v-card :loading="loading"
    class="pa-3"
    v-if="goal && goal.student"
    flat
    :color="$vuetify.theme.dark ? '#2d2d2d' : '#f9fafb'"
    height="100%"
  >
    <v-row>
      <v-col cols="12" lg="1" md="1" sm="0" xs="0"></v-col>
      <v-col cols="12" lg="10" md="10" sm="12" xs="12">
        <v-card class="rounded-a-lg my-5 " v-if="goal">
          <v-row class="pa-5">
            <v-col cols="12">
              <v-row dir="auto">
                <v-col cols="12" lg="6" md="6" sm="12">
                  <v-card flat>
                    <h3 class="text-title font-weight-bold">{{ goal.title }}</h3>
                    <p dir="auto">{{ goal.description }}</p>
                    <v-chip
                      :color="statusMap()[goal.progressStatus].color"
                      :dark="$vuetify.theme.dark"
                      outlined
                      label
                    >
                      {{ statusMap()[goal.progressStatus].name}}
                    </v-chip>
                    <v-chip
                      class="mx-2"
                      :color="
                        parseInt(goal.progressStatus) !== 2 && new Date(goal.dueDate) < new Date()
                          ? 'red'
                          : ''
                      "
                      :dark="$vuetify.theme.dark"
                      outlined
                      label
                    >
                      {{ $t("portfolio.Goals.dueDate") }}:
                      {{ goal.dueDate | moment("YYYY/MM/DD") }}
                    </v-chip>
                  </v-card>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="12" dir="auto">
                  <div class="d-flex flex-wrap justify-center">
                    <v-card
                      class="info text-center d-flex flex-column align-center justify-center ma-1"
                      width="150"
                      min-width="150"
                      flat
                      style="height: 80px"
                      :title="goal.createdDate | moment('YYYY-MM-DD - h:mm A')"
                    >
                      {{ $t("portfolio.general.createdDate") }}
                      <h5 class="font-weight-light font-weight-bold">
                        {{
                          new Date(goal.createdDate).toLocaleDateString($i18n.locale, {
                            year: "numeric",
                            month: "long",
                            day: "numeric"
                          })
                        }}
                      </h5>
                    </v-card>
                    <v-card
                      v-if="goal.modifiedDate"
                      class="info text-center d-flex flex-column align-center justify-center  ma-1"
                      width="150"
                      flat
                      min-width="150"
                      style="height: 80px"
                      :title="goal.modifiedDate | moment('YYYY-MM-DD - h:mm A')"
                    >
                      {{ $t("portfolio.general.modifiedDate") }}
                      <h5 class="font-weight-light font-weight-bold">
                        {{
                          goal.modifiedDate && new Date(goal.modifiedDate).getFullYear() > 1
                            ? new Date(goal.modifiedDate).toLocaleDateString($i18n.locale, {
                                year: "numeric",
                                month: "long",
                                day: "numeric"
                              })
                            : "-"
                        }}
                      </h5>
                    </v-card>
                    <v-card
                      class="info text-center d-flex flex-column align-center justify-center  ma-1"
                      width="150"
                      min-width="150"
                      flat
                      style="height: 80px"
                    >
                      {{ $t("studentName") }}
                      <h5 class="font-weight-light font-weight-bold">
                        {{ goal.student.studentFullName }}
                      </h5>
                    </v-card>
                  </div>
                </v-col>

                <v-row class="ma-0 pa-0" style="gap: 1rem;">
                  <v-col cols="12">
                    <TagsMini
                      @delete="deleteTag"
                      v-model="goal.tags"
                      :sourceGuid="goal.goalGuid"
                      sourceType="Goals"
                      :showAdd="this.isInRole(0)"
                      :isRemovable="this.isInRole(0)"
                    />
                  </v-col>
                </v-row>
              </v-row>
            </v-col>
          </v-row>
        </v-card>

        <v-card class="my-6">
          <v-tabs v-model="activeTab" background-color="transparent">
            <v-tab v-for="tab in tabs" :key="tab.name" :value="tab.name">
              {{ $t(tab.name) }} {{ tab.hash==='attachments' && goal.files.length>0  ? `(${goal.files.length})` : '' }}
            </v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <component
            style="min-height: 40rem;"
            :sourceGuid="goal.goalGuid"
            sourceType="3"
            :description="goal.description"
            :allowEdit="true"
            :ownerGuid="goal.student.studentGuid"
            v-model="goal.files"
            v-if="currentComponent"
            :is="currentComponent"
          ></component
        ></v-card>
      </v-col>
      <v-col cols="12" lg="1" md="1" sm="0" xs="0"></v-col>
    </v-row>

    <GoalsDialog ref="goalsDialog" @success="getGoal" />

    <v-fab-transition v-if="this.$store.state.userData.guid === goal.student.studentGuid">
      <v-btn
        :title="$t('edit')"
        color="secondary"
        fab
        large
        elevation="6"
        fixed
        bottom
        :left="$vuetify.rtl"
        :right="!$vuetify.rtl"
        class="v-btn--example"
        :class="$store.state.drawerMessage ? 'ml-16' : ''"
        :style="!$vuetify.rtl ? 'right:50px' : ''"
        @click="$refs.goalsDialog.showEditDialog(goal)"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-card>
</template>

<script>
import Comments from "@/views/dashboard/portfolio/comments/index.vue";
import Feedback from "@/views/dashboard/portfolio/feedback/index.vue";
import GoalsDialog from "@/components/portfolio/goals/goalsDialog.vue";
import TagsMini from "@/components/portfolio/tagsMini.vue";
import Attachments from "../attachment/index.vue";


export default {
  name: "ViewGoal",
  props: {},
  components: {
    Feedback,
    Comments,
    GoalsDialog,
    TagsMini,
    Attachments
  },
  data() {
    return {
      activeTab: "WorkSample.pages.feedback",
      tabs: [
        { name: "portfolio.WorkSample.pages.feedbacks", hash: "feedback" },
        { name: "portfolio.WorkSample.pages.comments", hash: "comments" },
        { name: "portfolio.WorkSample.pages.attachments", hash: "attachments" }
      ],
      goal: {
        goalGuid: null,
        title: "",
        description: "",
        dueDate: "",
        progressStatus: 0,
        visible: true
      },
      loading: true,
      error: null
    };
  },

  created() {
    this.getGoal();

    const { tab } = this.$route.query;
    if (tab) {
      const index = this.tabs.findIndex(t => t.hash === tab);
      if (index !== -1) {
        this.activeTab = index;
      }
    }
  },
  methods: {
  
    deleteTag(index) {
      this.goal.tags.splice(index, 1);
    },
    statusMap() {
      const statusNames = {
        0: {
          name: this.$t("portfolio.Goals.ProgressStatus.toDo"),
          color: "blue",
          icon: "mdi-checkbox-blank-circle-outline"
        },
        1: {
          name: this.$t("portfolio.Goals.ProgressStatus.inProgress"),
          color: "orange",
          icon: "mdi-progress-clock"
        },
        2: {
          name: this.$t("portfolio.Goals.ProgressStatus.achieved"),
          color: "green",
          icon: "mdi-check-circle-outline"
        },
        3: {
          name: this.$t("portfolio.Goals.ProgressStatus.later"),
          color: "grey",
          icon: "mdi-clock-outline"
        },
        4: {
          name: this.$t("portfolio.Goals.ProgressStatus.cancelled"),
          color: "red",
          icon: "mdi-close-circle-outline"
        }
      };
      return statusNames;
    },
    getGoal() {
      this.axios
        .get("Goal/Get/" + this.goalId)
        .then(res => {
          this.goal = res.data;
          this.loading = false;
        })
        .catch(error => {
          this.error = error;
          this.loading = false;
        });
    }
  },
  watch: {
    activeTab(newVal) {
      const currentTab = this.$route.query.tab;
      const newTab = this.tabs[newVal].hash;
      if (currentTab !== newTab) {
        this.$router.replace({ query: { tab: newTab } });
      }
    }
  },

  computed: {
    currentComponent() {
      const map = {
        0: "Feedback",
        1: "Comments",
        2: "Attachments"
      };
      return map[this.activeTab] || null;
    },
    goalId() {
      return this.$route.params.id;
    }
  }
};
</script>
